<!--  -->
<template>
    <div class='tabBox box'>
        <div v-for="(item,index) in arr" :key="index"
            :class="{'select': selectIndex==index }"
            class="tab-item"
            @click="clickTab(index)">{{item}}</div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    props:{
        arr:Array,
        isLoading:null,
        selectIndex:{
            type:Number,
            default:0,
        }
    },
    components: {},
    data() {
    //这里存放数据
        return {

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        //切换活动和草稿
        clickTab(index){
          if (this.isLoading) return
          if (this.selectIndex != index){
            this.$emit('changeTab',index)//传1为切换至草稿
          }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类

.tabBox{
    position:absolute;
    left:20px;
    height:30px;
    top:27px;
}
.tab-item{
    height:35px;
    line-height:35px;
    background-color: #fff;
    color:#999;
    padding:0 15px;
    font-size: 14px
}
.tab-item:first-child{
    border-radius:4px 0 0 4px
}
.tab-item:last-child{
    border-radius: 0 4px 4px 0
}
.tab-item:hover{
    cursor: pointer;
}
.select{
    background-color: #ff7b43;
    color:#fff;
}
</style>
